import $ from 'jquery/src/jquery';
import SiteNavMobile from "./site-nav-mobile";

export default () => {
    const nodeSelectors = {
        container: '[js-site-header="container"]',
    }

    function init() {
        if (!document.querySelector(nodeSelectors.container)) {
            return
        }

        initHeader()
    }

    function initHeader() {
        let scrollDirectionDown = true

        window.addEventListener('scroll', function() {
            /**
             * Hide/Show header on scroll
             * If user scrolls down header will be hidden or if user scrolls up header will be visible
             */
            scrollDirectionDown = this.oldScroll <= this.scrollY
            this.oldScroll = this.scrollY

            const scrollTop = window.scrollY;
            const docHeight = document.documentElement.scrollHeight - window.innerHeight;
            const scrollPercent = (scrollTop / docHeight) * 100;

            if (scrollPercent > 5) { // 20% scrolled, adjust as needed
                $(nodeSelectors.container).addClass('site-header--scrolled');
            } else {
                $(nodeSelectors.container).removeClass('site-header--scrolled');
            }

            if ( scrollDirectionDown ) {
                // Scrolling down
                if(
                    scrollPercent > 10
                    &&
                    !$(nodeSelectors.container).hasClass('site-header--nav-mobile-is-active')
                )
                    hide()
            } else {
                show()
            }
            /**
             * Hide/Show header on scroll END
             */

            if ( $('body').hasClass('admin-bar') && window.scrollY > 46 ) {
                $(nodeSelectors.container).addClass('admin-bar-is-active-but-not-in-view')
            } else {
                $(nodeSelectors.container).removeClass('admin-bar-is-active-but-not-in-view')
            }
        })
    }

    function show() {
        document.querySelector(nodeSelectors.container).style.top = '0px'
    }

    function hide() {
        SiteNavMobile().close()
        document.querySelector(nodeSelectors.container).style.top = - document.querySelector(nodeSelectors.container).offsetHeight + 'px'
    }

    return Object.freeze({
        init,
        nodeSelectors,
        show,
        hide
    })
}